import { Address } from './company';

export class Partner {
    uid: string;
    name: string;
    email: string;
    phone: string;
    cpf: string;
    partnershipDate: number;
    partnershipDateString: string;
    fileURL: string;

    bank: string;
    agency: string;
    account: string;

    address: Address;

    photoURL: string;
}



// WEBPACK FOOTER //
// ./src/app/model/partner.ts